import { useLayoutStore } from "./pinia/layout";
import { useAuthStore } from "./pinia/auth";
import { useNotificationStore } from "./pinia/notification";
import { useSocketStore } from "./pinia/socket";
import { createPinia } from "pinia";

const pinia = createPinia();
export default pinia;

export { useLayoutStore, useAuthStore, useNotificationStore, useSocketStore };
